module.exports = __webpack_public_path__ + "media/images/page/scene04-b44bb7a8a954a5031b10e0385c6a5061.jpg";